export default __webpack_public_path__ + "static/media/python.0f8ce437.svg";